import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { EstateHealthCheck } from '@/modules/estatehealthcheck/models/EstateHealthCheck';
import { Estate } from '@/modules/estate/models/Estate';
import { EstateHealthCheckEventType } from '@/modules/estatehealthcheck/constants/EstateHealthCheckEventType';
import { EstateHealthCheckEventValue } from '@/modules/estatehealthcheck/constants/EstateHealthCheckEventValue';
import type { EstateHealthCheckOptionEnum } from '@/modules/estatehealthcheck/constants/EstateHealthCheckOptionEnum';

export class EstateHealthCheckAnswer extends BaseEntityModel {
  id?: number;
  estateHealthCheckId?: number;
  estateId?: number;
  eventType?: string;
  value?: string;
  createdAt?: string;
  updatedAt?: string;

  estateHealthCheck?: Relationship<EstateHealthCheck>;
  estate?: Relationship<Estate>;

  constructor(model: Partial<EstateHealthCheckAnswer> = {}) {
    super(model);

    this.id = model.id;
    this.estateHealthCheckId = model.estateHealthCheckId;
    this.estateId = model.estateId;
    this.eventType = model.eventType;
    this.value = model.value;
    this.createdAt = model.createdAt;
    this.updatedAt = model.updatedAt;

    this.estateHealthCheck = EstateHealthCheck.mapModelOrNull(model.estateHealthCheck);
    this.estate = Estate.mapModel(model.estate);
  }

  get isFamilyEvent(): boolean {
    return this.eventType === EstateHealthCheckEventType.FAMILY_EVENTS;
  }

  get isPeopleInPlan(): boolean {
    return this.eventType === EstateHealthCheckEventType.PEOPLE_IN_PLAN;
  }

  get isLocation(): boolean {
    return this.eventType === EstateHealthCheckEventType.LOCATION;
  }

  get isMoneyAndProperty(): boolean {
    return this.eventType === EstateHealthCheckEventType.MONEY_AND_PROPERTY;
  }

  get isBusiness(): boolean {
    return this.eventType === EstateHealthCheckEventType.BUSINESS;
  }

  get isNoMajorChanges(): boolean {
    return this.value === EstateHealthCheckEventValue.NO_MAJOR_CHANGES;
  }

  resolveLabel(optionEnum: EstateHealthCheckOptionEnum | null): string {
    return optionEnum?.getByKey(this.value ?? '')?.value ?? this.value ?? '';
  }
}
